<template>
  <div class="full-height">
    <iframe :src="urlFrontVida" allow="clipboard-read; clipboard-write"></iframe>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import service from '../../services';

export default {
  name: 'NovaPropostaVida',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
  },
  watch: {
  },
  data() {
    return {
      decoded: null,
      idEmpresa: this.idEmpresaProps
        ? this.idEmpresaProps
        : this.$route.params.idEmpresa,
      id_usuario: null,
      userName: null,
      dadosConsultor: null,
      urlFrontVida: null,
    }
  },
  methods: {
    async defineRota() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idEmpresa = this.decoded.id_empresa;
        this.idUsuario = this.decoded.id_usuario;
        this.userName = this.decoded.userName;
      }

      await this.buscaDadosConsultor();

    },
    buscaDadosConsultor() {
      return new Promise((resolve, reject) => {
        var objSend = {
          idEmpresa: this.idEmpresa,
          userName: this.userName,
        };
        service
          .post('Usuario', 'buscarUsuario', objSend)
          .then((res) => {
            this.dadosConsultor = res.data[0];

            this.getUrlFrontVida();
            resolve();
          })
          .catch((e) => {
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            reject(e);
          });
      });
    },
    getUrlFrontVida() {
      this.urlFrontVida = `${process.env.VUE_APP_FRONT_VIDA_URL}/${this.dadosConsultor.apiToken}`;
    }
  },
  async created() {
    await this.defineRota();
  },
}
</script>
<style lang="scss" scoped>
  .full-height {
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 800px;
    border: none;
  }
</style>
